import { render } from "./ExtraMenu.vue?vue&type=template&id=748e3501"
import script from "./ExtraMenu.vue?vue&type=script&lang=js"
export * from "./ExtraMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__